import React, { useState } from 'react';
import { FaBriefcase, FaUserTie, FaCalculator, FaClipboardCheck, FaFileAlt, FaChartBar, FaUsers, FaCheckCircle, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaBuilding, FaShieldAlt, FaUsersCog } from 'react-icons/fa';

const SSCPage = () => {
  const [expandedExam, setExpandedExam] = useState(null);
  const [expandedDept, setExpandedDept] = useState(null);

  const sscExams = [
    {
      id: 'cgl',
      name: 'SSC CGL (Combined Graduate Level)',
      icon: <FaUserTie />,
      eligibility: 'Bachelor\'s Degree',
      ageLimit: '18-32 years',
      description: 'Premier examination for Group B and C posts in various ministries and departments',
      tiers: [
        { name: 'Tier I', type: 'Computer Based (Objective)', subjects: 'General Intelligence, Quantitative Aptitude, English, General Awareness' },
        { name: 'Tier II', type: 'Computer Based (Objective)', subjects: 'Quantitative Abilities, English Language, Statistics, General Studies' },
        { name: 'Tier III', type: 'Descriptive Paper', subjects: 'Essay/Letter/Application Writing' },
        { name: 'Tier IV', type: 'Skill Test/Computer Proficiency', subjects: 'Data Entry Speed Test/Computer Proficiency Test' }
      ]
    },
    {
      id: 'chsl',
      name: 'SSC CHSL (Combined Higher Secondary Level)',
      icon: <FaClipboardCheck />,
      eligibility: '12th Pass',
      ageLimit: '18-27 years',
      description: 'For Lower Division Clerk, Junior Secretariat Assistant, Postal Assistant, and Data Entry Operator posts',
      tiers: [
        { name: 'Tier I', type: 'Computer Based (Objective)', subjects: 'English, General Intelligence, Quantitative Aptitude, General Awareness' },
        { name: 'Tier II', type: 'Descriptive Paper', subjects: 'Essay/Letter/Application in English or Hindi' },
        { name: 'Tier III', type: 'Skill Test', subjects: 'Typing Test (English/Hindi)' }
      ]
    },
    {
      id: 'cpo',
      name: 'SSC CPO (Central Police Organisation)',
      icon: <FaShieldAlt />,
      eligibility: 'Bachelor\'s Degree',
      ageLimit: '20-25 years',
      description: 'Recruitment for Sub-Inspectors in Delhi Police, CAPF, and CISF',
      tiers: [
        { name: 'Paper I', type: 'Computer Based (Objective)', subjects: 'General Intelligence, Quantitative Aptitude, English, General Awareness' },
        { name: 'Paper II', type: 'Computer Based (Objective)', subjects: 'English Language & Comprehension' },
        { name: 'Physical Test', type: 'Physical Efficiency & Medical', subjects: 'Race, High Jump, Long Jump, Medical Examination' },
        { name: 'Final', type: 'Interview', subjects: 'Personality Test' }
      ]
    },
    {
      id: 'gd',
      name: 'SSC GD (General Duty Constable)',
      icon: <FaUsers />,
      eligibility: '10th Pass',
      ageLimit: '18-23 years',
      description: 'Recruitment for Constables in CAPFs, NIA, SSF, and Rifleman in Assam Rifles',
      tiers: [
        { name: 'Computer Based Test', type: 'Objective Type', subjects: 'General Intelligence, General Knowledge, Elementary Mathematics, English/Hindi' },
        { name: 'Physical Test', type: 'Physical Efficiency Test', subjects: 'Race, Physical Standards' },
        { name: 'Medical Examination', type: 'Medical Standards', subjects: 'As per CAPF requirements' }
      ]
    },
    {
      id: 'steno',
      name: 'SSC Stenographer',
      icon: <FaFileAlt />,
      eligibility: '12th Pass',
      ageLimit: '18-30 years',
      description: 'For Stenographer Grade C and D in various ministries and departments',
      tiers: [
        { name: 'Computer Based Test', type: 'Objective Type', subjects: 'General Intelligence, General Awareness, English Language' },
        { name: 'Skill Test', type: 'Stenography Test', subjects: 'Dictation (English/Hindi) - 100 wpm for Grade C, 80 wpm for Grade D' }
      ]
    },
    {
      id: 'je',
      name: 'SSC JE (Junior Engineer)',
      icon: <FaBuilding />,
      eligibility: 'Engineering Degree/Diploma',
      ageLimit: '18-32 years',
      description: 'For Junior Engineer posts in Civil, Electrical, and Mechanical departments',
      tiers: [
        { name: 'Paper I', type: 'Computer Based (Objective)', subjects: 'General Intelligence, General Awareness, Engineering Subject' },
        { name: 'Paper II', type: 'Written (Descriptive)', subjects: 'Engineering Subject (Civil/Electrical/Mechanical)' }
      ]
    },
    {
      id: 'mts',
      name: 'SSC MTS (Multi Tasking Staff)',
      icon: <FaUsersCog />,
      eligibility: '10th Pass',
      ageLimit: '18-25 years',
      description: 'For Group C non-gazetted, non-ministerial posts',
      tiers: [
        { name: 'Paper I', type: 'Computer Based (Objective)', subjects: 'General Intelligence, Numerical Aptitude, General English, General Awareness' },
        { name: 'Paper II', type: 'Descriptive', subjects: 'Short Essay/Letter in English or Hindi' }
      ]
    }
  ];

  const departments = [
    {
      id: 'finance',
      name: 'Ministry of Finance',
      icon: <FaCalculator />,
      posts: [
        { role: 'Assistant Audit Officer', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Tax Assistant', exam: 'SSC CGL', grade: 'Group C' },
        { role: 'Junior Accountant', exam: 'SSC CHSL', grade: 'Group C' },
        { role: 'Auditor', exam: 'SSC CGL', grade: 'Group B' }
      ]
    },
    {
      id: 'revenue',
      name: 'Central Board of Direct Taxes (CBDT)',
      icon: <FaChartBar />,
      posts: [
        { role: 'Income Tax Inspector', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Tax Assistant', exam: 'SSC CGL', grade: 'Group C' }
      ]
    },
    {
      id: 'customs',
      name: 'Central Board of Indirect Taxes (CBIC)',
      icon: <FaBriefcase />,
      posts: [
        { role: 'Inspector (Central Excise)', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Inspector (Preventive Officer)', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Inspector (Examiner)', exam: 'SSC CGL', grade: 'Group B' }
      ]
    },
    {
      id: 'police',
      name: 'Central Police Organizations',
      icon: <FaShieldAlt />,
      posts: [
        { role: 'Sub-Inspector (Delhi Police)', exam: 'SSC CPO', grade: 'Group B' },
        { role: 'Sub-Inspector (CAPF)', exam: 'SSC CPO', grade: 'Group B' },
        { role: 'Sub-Inspector (CISF)', exam: 'SSC CPO', grade: 'Group B' },
        { role: 'Constable (GD)', exam: 'SSC GD', grade: 'Group C' },
        { role: 'Rifleman (Assam Rifles)', exam: 'SSC GD', grade: 'Group C' }
      ]
    },
    {
      id: 'postal',
      name: 'Department of Posts',
      icon: <FaFileAlt />,
      posts: [
        { role: 'Postal Assistant', exam: 'SSC CHSL', grade: 'Group C' },
        { role: 'Sorting Assistant', exam: 'SSC CHSL', grade: 'Group C' },
        { role: 'Postman', exam: 'SSC GD', grade: 'Group C' }
      ]
    },
    {
      id: 'accounts',
      name: 'Controller General of Accounts (CGA)',
      icon: <FaCalculator />,
      posts: [
        { role: 'Assistant Accounts Officer', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Junior Accountant', exam: 'SSC CHSL', grade: 'Group C' }
      ]
    },
    {
      id: 'cag',
      name: 'Comptroller & Auditor General (CAG)',
      icon: <FaClipboardCheck />,
      posts: [
        { role: 'Assistant Audit Officer', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Auditor', exam: 'SSC CGL', grade: 'Group B' }
      ]
    },
    {
      id: 'statistics',
      name: 'Ministry of Statistics',
      icon: <FaChartBar />,
      posts: [
        { role: 'Statistical Investigator', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Junior Statistical Officer', exam: 'SSC CGL', grade: 'Group B' }
      ]
    },
    {
      id: 'ministry',
      name: 'Various Central Ministries',
      icon: <FaBuilding />,
      posts: [
        { role: 'Assistant', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Upper Division Clerk (UDC)', exam: 'SSC CGL', grade: 'Group C' },
        { role: 'Lower Division Clerk (LDC)', exam: 'SSC CHSL', grade: 'Group C' },
        { role: 'Junior Secretariat Assistant (JSA)', exam: 'SSC CHSL', grade: 'Group C' },
        { role: 'Stenographer Grade C', exam: 'SSC Steno', grade: 'Group C' },
        { role: 'Stenographer Grade D', exam: 'SSC Steno', grade: 'Group C' }
      ]
    },
    {
      id: 'engineering',
      name: 'Engineering Departments',
      icon: <FaBuilding />,
      posts: [
        { role: 'Junior Engineer (Civil)', exam: 'SSC JE', grade: 'Group B' },
        { role: 'Junior Engineer (Electrical)', exam: 'SSC JE', grade: 'Group B' },
        { role: 'Junior Engineer (Mechanical)', exam: 'SSC JE', grade: 'Group B' }
      ]
    },
    {
      id: 'investigation',
      name: 'Intelligence & Investigation',
      icon: <FaShieldAlt />,
      posts: [
        { role: 'Inspector (CBIC)', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Inspector (Narcotics)', exam: 'SSC CGL', grade: 'Group B' },
        { role: 'Sub-Inspector (CBI)', exam: 'SSC CGL', grade: 'Group B' }
      ]
    }
  ];

  const subjects = [
    {
      name: 'Quantitative Aptitude',
      topics: ['Number Systems', 'Simplification', 'Decimals & Fractions', 'LCM & HCF', 'Ratio & Proportion', 'Percentage', 'Profit & Loss', 'Discount', 'Simple & Compound Interest', 'Time & Work', 'Time & Distance', 'Mensuration', 'Geometry', 'Trigonometry', 'Algebra', 'Data Interpretation']
    },
    {
      name: 'General Intelligence & Reasoning',
      topics: ['Analogies', 'Similarities & Differences', 'Problem Solving', 'Analysis & Judgment', 'Decision Making', 'Visual Memory', 'Discrimination', 'Observation', 'Relationship Concepts', 'Arithmetical Reasoning', 'Verbal & Figure Classification', 'Series', 'Coding-Decoding', 'Blood Relations', 'Direction Sense', 'Syllogism', 'Puzzles']
    },
    {
      name: 'English Language',
      topics: ['Vocabulary', 'Grammar', 'Sentence Structure', 'Synonyms & Antonyms', 'Spelling Correction', 'Error Detection', 'Fill in the Blanks', 'Idioms & Phrases', 'One Word Substitution', 'Active & Passive Voice', 'Direct & Indirect Speech', 'Cloze Test', 'Reading Comprehension', 'Para Jumbles', 'Sentence Improvement']
    },
    {
      name: 'General Awareness',
      topics: ['Indian History', 'Indian Geography', 'Indian Polity & Constitution', 'Indian Economy', 'General Science', 'Current Affairs', 'Books & Authors', 'Sports', 'Important Days', 'Awards & Honors', 'Science & Technology', 'Environment & Ecology', 'International Organizations', 'Famous Personalities', 'Art & Culture', 'Static GK']
    }
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'Tier-wise Preparation',
      description: 'Structured courses for each tier of SSC exams with focused study material'
    },
    {
      icon: <FaLaptop />,
      title: 'Online Test Series',
      description: 'Regular mock tests simulating actual exam pattern with detailed analysis'
    },
    {
      icon: <FaUsers />,
      title: 'Expert Guidance',
      description: 'Learn from experienced faculty who understand SSC exam patterns thoroughly'
    },
    {
      icon: <FaClock />,
      title: 'Time Management',
      description: 'Special sessions on speed and accuracy to maximize your score'
    },
    {
      icon: <FaFileAlt />,
      title: 'Previous Year Papers',
      description: 'Comprehensive collection of previous years questions with solutions'
    },
    {
      icon: <FaTrophy />,
      title: 'Success Track Record',
      description: 'Proven methodology with thousands of successful candidates'
    }
  ];

  const toggleExam = (id) => {
    setExpandedExam(expandedExam === id ? null : id);
  };

  const toggleDept = (id) => {
    setExpandedDept(expandedDept === id ? null : id);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <div className="text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-3">SSC Examination Training</h1>
              <p className="lead mb-4">
                Comprehensive coaching for Staff Selection Commission exams. Join India's largest recruitment body and serve in prestigious government positions across ministries and departments.
              </p>
              <button className="btn btn-light btn-lg px-4 me-3">Enroll Now</button>
              <button className="btn btn-outline-light btn-lg px-4">View Courses</button>
            </div>
            <div className="col-lg-4 text-center">
              <FaBriefcase size={150} className="opacity-75" />
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="container py-4">
        <div className="row g-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-primary fw-bold mb-1">50,000+</h3>
              <p className="text-muted mb-0">Annual Vacancies</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-success fw-bold mb-1">7+</h3>
              <p className="text-muted mb-0">Major Exams</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-info fw-bold mb-1">100+</h3>
              <p className="text-muted mb-0">Departments</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-warning fw-bold mb-1">Lakhs</h3>
              <p className="text-muted mb-0">Aspirants Annually</p>
            </div>
          </div>
        </div>
      </div>

      {/* SSC Exams */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">SSC Examination Categories</h2>
        <div className="row">
          <div className="col-12">
            {sscExams.map((exam) => (
              <div key={exam.id} className="card mb-3 border-0 shadow-sm">
                <div 
                  className="card-header bg-light d-flex justify-content-between align-items-center"
                  onClick={() => toggleExam(exam.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="text-primary me-3" style={{ fontSize: '1.5rem' }}>
                      {exam.icon}
                    </div>
                    <div>
                      <h5 className="mb-1 fw-bold text-primary">{exam.name}</h5>
                      <small className="text-muted">{exam.description}</small>
                    </div>
                  </div>
                  {expandedExam === exam.id ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {expandedExam === exam.id && (
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <p className="mb-1"><strong>Eligibility:</strong> {exam.eligibility}</p>
                      </div>
                      <div className="col-md-6">
                        <p className="mb-1"><strong>Age Limit:</strong> {exam.ageLimit}</p>
                      </div>
                    </div>
                    <h6 className="fw-bold mb-3">Examination Structure:</h6>
                    <div className="row g-3">
                      {exam.tiers.map((tier, idx) => (
                        <div key={idx} className="col-md-6">
                          <div className="border rounded p-3">
                            <h6 className="text-primary fw-bold">{tier.name}</h6>
                            <p className="mb-1 small"><strong>Type:</strong> {tier.type}</p>
                            <p className="mb-0 small"><strong>Subjects:</strong> {tier.subjects}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Departments Section */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-4 fw-bold">Departments & Roles</h2>
          <p className="text-center text-muted mb-5">
            SSC recruits for over 100+ departments and organizations. Here are the major departments and available positions:
          </p>
          <div className="row">
            <div className="col-12">
              {departments.map((dept) => (
                <div key={dept.id} className="card mb-3 border-0 shadow-sm">
                  <div 
                    className="card-header d-flex justify-content-between align-items-center"
                    onClick={() => toggleDept(dept.id)}
                    style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                  >
                    <div className="d-flex align-items-center">
                      <div className="text-primary me-3" style={{ fontSize: '1.5rem' }}>
                        {dept.icon}
                      </div>
                      <h5 className="mb-0 fw-bold">{dept.name}</h5>
                    </div>
                    {expandedDept === dept.id ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                  {expandedDept === dept.id && (
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="table-light">
                            <tr>
                              <th>Role/Position</th>
                              <th>Exam</th>
                              <th>Grade</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dept.posts.map((post, idx) => (
                              <tr key={idx}>
                                <td className="fw-semibold">{post.role}</td>
                                <td><span className="badge bg-primary">{post.exam}</span></td>
                                <td><span className="badge bg-info">{post.grade}</span></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Syllabus Section */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Common Subjects Across SSC Exams</h2>
        <div className="row g-4">
          {subjects.map((subject, idx) => (
            <div key={idx} className="col-md-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <h5 className="fw-bold text-primary mb-3">{subject.name}</h5>
                  <div className="row">
                    {subject.topics.map((topic, topicIdx) => (
                      <div key={topicIdx} className="col-12 mb-2">
                        <FaCheckCircle className="text-success me-2" size={12} />
                        <small>{topic}</small>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pay Scale Section */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Salary & Benefits</h2>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <h3 className="text-primary fw-bold">Group B</h3>
                <h4 className="mb-3">₹44,900 - ₹1,42,400</h4>
                <p className="text-muted mb-0">Per Month (7th Pay Commission)</p>
                <small className="text-muted">Includes DA, HRA & Other Allowances</small>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <h3 className="text-success fw-bold">Group C</h3>
                <h4 className="mb-3">₹18,000 - ₹56,900</h4>
                <p className="text-muted mb-0">Per Month (7th Pay Commission)</p>
                <small className="text-muted">Includes DA, HRA & Other Allowances</small>
              </div>
            </div>
             <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <h3 className="text-success fw-bold">Group C</h3>
                <h4 className="mb-3">₹18,000 - ₹56,900</h4>
                <p className="text-muted mb-0">Per Month (7th Pay Commission)</p>
                <small className="text-muted">Includes DA, HRA & Other Allowances</small>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <h3 className="text-info fw-bold">Additional Benefits</h3>
                <ul className="list-unstyled text-start mt-3">
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Medical Facilities</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Pension Benefits</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Leave Travel Allowance</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Government Quarters</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Job Security</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <h3 className="text-info fw-bold">Additional Benefits</h3>
                <ul className="list-unstyled text-start mt-3">
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Medical Facilities</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Pension Benefits</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Leave Travel Allowance</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Government Quarters</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Job Security</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <h3 className="text-info fw-bold">Additional Benefits</h3>
                <ul className="list-unstyled text-start mt-3">
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Medical Facilities</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Pension Benefits</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Leave Travel Allowance</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Government Quarters</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" />Job Security</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Why Choose Our SSC Training?</h2>
        <div className="row g-4">
          {features.map((feature, idx) => (
            <div key={idx} className="col-md-4">
              <div className="card border-0 shadow-sm h-100 text-center p-4">
                <div className="text-primary mb-3" style={{ fontSize: '3rem' }}>
                  {feature.icon}
                </div>
                <h5 className="fw-bold mb-3">{feature.title}</h5>
                <p className="text-muted">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Career Path */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Career Growth Path</h2>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card border-primary h-100">
                <div className="card-header bg-primary text-white text-center">
                  <h5 className="mb-0">Entry Level</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-2">✓ Tax Assistant</li>
                    <li className="mb-2">✓ LDC/JSA</li>
                    <li className="mb-2">✓ Postal Assistant</li>
                    <li className="mb-2">✓ Stenographer D</li>
                    <li className="mb-2">✓ Constable GD</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-success h-100">
                <div className="card-header bg-success text-white text-center">
                  <h5 className="mb-0">Mid Level</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-2">✓ Inspector (Taxes)</li>
                    <li className="mb-2">✓ Sub-Inspector</li>
                    <li className="mb-2">✓ UDC/Assistant</li>
                    <li className="mb-2">✓ Auditor</li>
                    <li className="mb-2">✓ Junior Engineer</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-info h-100">
                <div className="card-header bg-info text-white text-center">
                  <h5 className="mb-0">Senior Level</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-2">✓ Assistant Commissioner</li>
                    <li className="mb-2">✓ Deputy Superintendent</li>
                    <li className="mb-2">✓ Section Officer</li>
                    <li className="mb-2">✓ Senior Auditor</li>
                    <li className="mb-2">✓ Assistant Engineer</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container py-5">
        <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <div className="card-body text-white text-center p-5">
            <h2 className="fw-bold mb-3">Ready to Start Your SSC Journey?</h2>
            <p className="lead mb-4">
              Join thousands of successful candidates who achieved their dreams with our comprehensive training
            </p>
            <button className="btn btn-light btn-lg px-5 me-3">Enroll Today</button>
            <button className="btn btn-outline-light btn-lg px-5">Download Syllabus</button>
          </div>
        </div>
      </div>

     
    </div>
  );
};

export default SSCPage;